import getEndpointFromClassNameModelUtil from 'models/utils/get-endpoint-from-class-name'

export default function getEndpointFromDomainMapValueReduxUtil (className, domainMapValue) {
  const endpoint = getEndpointFromClassNameModelUtil(className)
  return endpoint + '/' + domainMapValue
}
